import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "background-wrapper" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'BackgroundImage',
    setup(__props) {
        // 组件逻辑
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
                _createElementVNode("div", { class: "background-image" }, null, -1)
            ])));
        };
    }
});
